<template>
  <div class="">
    <p v-if="!$store.state.errorMessage">
      {{ message }}
    </p>
    <div
      v-if="$store.state.errorMessage"
      style="color: red;">
      <p>エラー：</p>
      <p>{{ $store.state.errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { auth } from '@/plugins/firebase'

export default {
  data: function() {
    return {
      message: 'サインイン中です...',
    }
  },
  mounted() {
    let me = this
    auth.getRedirectResult()
      .then(function() {
        me.setErrorMessage('')
      })
      .catch(function(error) {
        if (
          error.code ===
                    'auth/account-exists-with-different-credential'
        ) {
          me.setErrorMessage(
            '同じメールアドレスで既にユーザ登録されています。'
          )
        }
      })

    auth.onAuthStateChanged((user) => {
      if (user) {
        this.setLoginUser(user)
        this.fetchUserMeishiki()
      }
    })
  },
  methods: {
    ...mapActions([
      'setLoginUser',
      'deleteLoginUser',
      'fetchUserMeishiki',
      'setErrorMessage',
    ]),
  },
}
</script>
